export default __webpack_public_path__ + "static/header-ee07abb43eb80a54532222e3c7896df5.png";